import { render } from "./SimilarProductCard.vue?vue&type=template&id=1f5e8cea&scoped=true"
import script from "./SimilarProductCard.vue?vue&type=script&lang=js"
export * from "./SimilarProductCard.vue?vue&type=script&lang=js"

import "./SimilarProductCard.vue?vue&type=style&index=0&id=1f5e8cea&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5e8cea"]])

export default __exports__